import axios from 'axios'
import { BASE_API_URL } from '../constants'

const ONE_SECOND = 1000

export const customAxios = axios.create({
  baseURL: BASE_API_URL,
  timeout: ONE_SECOND * 30,
  headers: {
    'Content-Type': 'application/json'
    // 'Content-Type': 'multipart/form-data'
  }
})
